var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIcon1 = function SvgCheckIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.672 7.63.3 5.098a1.138 1.138 0 0 1 .012-1.551 1.008 1.008 0 0 1 1.475.011L3.428 5.31 8.25.315a1.008 1.008 0 0 1 1.475.012 1.138 1.138 0 0 1-.012 1.55L4.147 7.643c-.41.425-1.071.42-1.475-.011Z",
    fill: "#fff"
  })));
};
export default SvgCheckIcon1;